import {alpha, Box, Grid, Skeleton} from "@mui/material";
import React from "react";

const ExperienceAddOnSkeleton = () => (
  <Box className="fluid-box" sx={{ backgroundColor: "background.cool_strong" }}>
    <Box
      className="full-width-container"
      sx={{
        padding: { xs: "4rem 2.4rem", lg: "4rem 6.5rem" },
        display: "flex",
        flexDirection: "column",
        gap: { xs: "4rem" }
      }}
    >
      {/* Section Header Skeleton */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: "1.2rem", alignItems: "center" }}>
        <Skeleton
          variant="text"
          width="30%"
          height={42}
          animation="wave"
          sx={{ 
            borderRadius: "8px"
          }}
        />
        <Skeleton
          variant="text"
          width="45%"
          height={24}
          animation="wave"
          sx={{ 
            borderRadius: "8px"
          }}
        />
      </Box>

      {/* Cards Grid Skeleton */}
      <Grid container rowSpacing="4rem" columnSpacing="2.4rem">
        {[1, 2].map((i) => (
          <Grid size={{ xs: 12, lg: 6 }} key={i}>
            <Box
              sx={{
                borderRadius: "2rem",
                backgroundColor: "background.default",
                border: "1px solid",
                borderColor: "divider",
                display: "flex",
                flexDirection: "row",
                minHeight: "15rem",
                overflow: "hidden",
                boxShadow: 6
              }}
            >
              <Skeleton
                variant="rectangular"
                animation="wave"
                sx={{
                  width: "15rem",
                  minHeight: "15rem",
                  flexShrink: 0
                }}
              />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  gap: "0.8rem",
                  padding: "1.6rem 2.4rem",
                  flex: 1
                }}
              >
                {/* Title - multiple lines for realistic text */}
                <Box sx={{ display: "flex", flexDirection: "column", gap: "0.6rem" }}>
                  <Skeleton 
                    variant="text" 
                    width="85%" 
                    height={20} 
                    animation="wave"
                    sx={{
                      borderRadius: "4px"
                    }}
                  />
                  <Skeleton 
                    variant="text" 
                    width="60%" 
                    height={20} 
                    animation="wave"
                    sx={{ 
                      bgcolor: (theme) => alpha(theme.palette.common.black, 0.08),
                      borderRadius: "4px"
                    }}
                  />
                </Box>

                {/* Price only - removed button */}
                <Skeleton 
                  variant="text" 
                  width="40%" 
                  height={24} 
                  animation="wave"
                  sx={{ 
                    bgcolor: (theme) => alpha(theme.palette.common.black, 0.08),
                    borderRadius: "4px"
                  }}
                />
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  </Box>
);

export default ExperienceAddOnSkeleton;
